import { normalizarYoutubeWatch } from "./youtube";

function normalizarArquivoLocal(valor) {
  if (typeof window === "undefined") return valor;

  const emDesenvolvimento =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (emDesenvolvimento) {
    return `http://127.0.0.1:8000${valor}`;
  }

  return `/api${valor}`;
}

export function normalizarUrlArquivo(valor) {
  if (!valor) return "";

  const url = String(valor).trim();

  if (/\/storage\/?$/i.test(url) || /\/uploads\/?$/i.test(url)) {
    return "/assets/EM-DESENVOLVIMENTO.png";
  }

  if (/^\/uploads\//i.test(url) || /^\/storage\//i.test(url)) {
    return normalizarArquivoLocal(url);
  }

  return url
    .replace(/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/storage\//i, "http://127.0.0.1:8000/storage/")
    .replace(/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/uploads\//i, "http://127.0.0.1:8000/uploads/")
    .replace(/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/assets\//i, "/assets/");
}

export function chaveTag(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}


export function normalizarTextoBusca(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function projetoCorrespondeBusca(projeto, termo) {
  const busca = normalizarTextoBusca(termo);
  if (!busca) return true;

  const campos = [
    projeto?.titulo,
    projeto?.descricao,
    projeto?.info,
    ...(Array.isArray(projeto?.tags) ? projeto.tags : []),
  ];

  return campos.some((campo) => normalizarTextoBusca(campo).includes(busca));
}

export function normalizarLinkExterno(valor) {
  const link = String(valor || "").trim();
  if (!link) return "";

  if (/^(https?:|mailto:|tel:)/i.test(link)) return link;
  if (/^\/\//.test(link)) return `https:${link}`;
  if (/^[\w.-]+\.[a-z]{2,}([/?#].*)?$/i.test(link)) return `https://${link}`;

  return link;
}
export function normalizarTipo(valor) {
  const chave = chaveTag(valor);

  if (chave === "rv" || chave.includes("realidade virtual")) return "RV";
  if (chave === "ra" || chave.includes("realidade aumentada")) return "RA";
  if (chave.includes("360i")) return "Video 360i";
  if (chave.includes("360")) return "Video 360";

  return "";
}

export function labelTipo(tipo) {
  const normalizado = normalizarTipo(tipo);

  if (normalizado === "Video 360") return "Vídeo 360";
  if (normalizado === "Video 360i") return "Vídeo 360i";

  return normalizado;
}

export function obterTipoProjeto(projeto) {
  const tipoDireto = normalizarTipo(projeto?.tipo);
  if (tipoDireto) return tipoDireto;

  const tags = Array.isArray(projeto?.tags) ? projeto.tags : [];

  for (const tag of tags) {
    const tipo = normalizarTipo(tag);
    if (tipo) return tipo;
  }

  return "";
}

export function projetoEhDoTipo(projeto, tipo) {
  const tipoEsperado = normalizarTipo(tipo);
  const tipoDireto = normalizarTipo(projeto?.tipo);

  if (tipoDireto) return tipoDireto === tipoEsperado;

  const tags = Array.isArray(projeto?.tags) ? projeto.tags : [];
  return tags.some((tag) => normalizarTipo(tag) === tipoEsperado);
}

export function normalizarProjetoBackend(card, options = {}) {
  let tipo = "";
  let apresentacao = { tipo: "imagem", arquivo: "", url: "" };
  let tags = [];
  let disponibilidade = [];

  if (card.content) {
    try {
      const parsed = JSON.parse(card.content);
      if (parsed && typeof parsed === "object") {
        tipo = normalizarTipo(parsed.tipo);
        apresentacao = parsed.apresentacao || apresentacao;
        tags = Array.isArray(parsed.tags) ? parsed.tags : [];
        disponibilidade = Array.isArray(parsed.disponibilidade)
          ? parsed.disponibilidade
          : [];
      } else {
        apresentacao = { tipo: "imagem", arquivo: String(card.content), url: "" };
      }
    } catch (error) {
      apresentacao = { tipo: "imagem", arquivo: String(card.content), url: "" };
    }
  }

  apresentacao = {
    tipo: "imagem",
    arquivo: normalizarUrlArquivo(apresentacao.arquivo),
    url: "",
  };

  disponibilidade = disponibilidade.map((item) => {
    if (item.tipo === "Youtube") {
      return {
        ...item,
        link: normalizarYoutubeWatch(item.link || item.url || ""),
      };
    }

    return {
      ...item,
      link: normalizarLinkExterno(item.link || item.url || ""),
    };
  });

  const projeto = {
    id: options.admin ? card.id : `backend-${card.id}`,
    originalId: card.id,
    source: "backend",
    titulo: card.title,
    descricao: card.description,
    info: card.info,
    tipo,
    apresentacao,
    tags,
    disponibilidade,
    created_at: card.created_at,
    updated_at: card.updated_at,
  };

  return {
    ...projeto,
    tipo: obterTipoProjeto(projeto),
  };
}